import PropTypes from 'prop-types';

import { rxPropType } from 'Shared/types';

const patientMedicationRxPropType = PropTypes.shape({
    id: PropTypes.string,
    patientId: PropTypes.string,
    medication: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        groupId: PropTypes.string,
    }),
    status: PropTypes.shape({
        id: PropTypes.number,
        start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
        end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
        endReason: PropTypes.string,
    }),
    rxs: PropTypes.arrayOf(rxPropType),
});

export default patientMedicationRxPropType;
